// Shared crusher_prefs storage helpers.
//
// Used by framework components that read/write user preferences. Handles:
//   - schema versioning (v: 1; future v > 1 is read-only with one warn per session)
//   - try/catch on localStorage access (Safari private mode, blocked storage)
//   - JSON.parse failure (treat as empty)
//
// API:
//   readPrefsState()         -> { prefs, readOnly }  (pre-M1 prefs up-migrated in memory)
//   writePrefs(prefsOrFn)    -> boolean (true if write succeeded, false if read-only/blocked)
//
// writePrefs accepts either a plain prefs object OR a function
// (currentPrefs) => nextPrefs. The function form is preferred because
// it reads + writes in a single pass, eliminating the double-read TOCTOU
// where another tab's write between read and write could be lost.

export const PREFS_KEY = 'crusher_prefs';
export const SCHEMA_VERSION = 1;

let schemaWarned = false;

export function readPrefsState() {
  if (typeof localStorage === 'undefined') return { prefs: {}, readOnly: false };
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return { prefs: {}, readOnly: false };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return { prefs: {}, readOnly: false };
    if (parsed.v == null) {
      parsed.v = SCHEMA_VERSION;
      return { prefs: parsed, readOnly: false };
    }
    if (typeof parsed.v === 'number' && parsed.v > SCHEMA_VERSION) {
      if (!schemaWarned) {
        schemaWarned = true;
        console.warn('crusher_prefs schema v=' + parsed.v + ' ahead of runtime v=' + SCHEMA_VERSION + '; running in read-only mode');
      }
      return { prefs: parsed, readOnly: true };
    }
    return { prefs: parsed, readOnly: false };
  } catch { return { prefs: {}, readOnly: false }; }
}

export function writePrefs(prefsOrFn) {
  const { prefs, readOnly } = readPrefsState();
  if (readOnly) return false;
  const next = typeof prefsOrFn === 'function' ? prefsOrFn(prefs) : prefsOrFn;
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify({ ...next, v: SCHEMA_VERSION }));
    return true;
  } catch { return false; }
}
